import { Box, Button, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import { useTheme } from "@mui/material";
import { myNFTs } from "../../../data/dummyNfts";
import styled from "@emotion/styled";
import { conciseAddress } from "../../../utils/formatters";

const StyledButton = styled(Button)(({ theme, colors, selected }) => ({
  backgroundColor: selected ? colors.primary[500] : colors.whiteAccent[900],
  color: selected ? colors.whiteAccent[900] : colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: "95px",
  height: "38px",
  borderRadius: "4px",
  borderColor: colors.primary[500],
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

const ScholarTableView = ({ data, scholarSelected, setScholarSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    {
      field: "name",
      headerName: "Scholar",
      flex: 1,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <Stack direction="row" alignItems={"center"} justifyContent="center">
          <img
            src={params.row.profilePic}
            alt="nft"
            style={{ width: "44px", height: "55px", borderRadius: "13px" }}
          />
          <Stack direction="column" ml={"10px"}>
            <Typography
              variant="caption"
              color={colors.black[500]}
              fontWeight={500}
            >
              {params.row.scholarName.length > 20
                ? conciseAddress(params.row.scholarName)
                : params.row.scholarName}
            </Typography>
            <Typography
              variant="fs13"
              color={colors.black[800]}
              fontWeight={500}
            >
              {conciseAddress(params.row.scholarAddress)}
            </Typography>
          </Stack>
        </Stack>
      ),
    },
    {
      field: "lastActive",
      headerName: "Last Active",
      flex: 0.5,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="caption"
          color={colors.black[500]}
          fontWeight={500}
        >
          1 Day ago
        </Typography>
      ),
    },
    {
      field: "totalNfts",
      headerName: "NFTs",
      sortable: false,
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="caption"
          color={colors.black[500]}
          fontWeight={500}
        >
          {params.row?.totalBorrowedNfts || 0}
        </Typography>
      ),
    },
    {
      field: "earnings",
      headerName: "Earnings",
      sortable: false,
      flex: 0.7,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="caption"
          color={colors.black[500]}
          fontWeight={500}
        >
          $3,585
        </Typography>
      ),
    },
    {
      field: "select",
      headerName: "Select",
      flex: 0.5,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <StyledButton
          onClick={() => {
            if (scholarSelected === params.row.scholarAddress) {
              setScholarSelected("");
            } else {
              setScholarSelected(params.row.scholarAddress);
            }
          }}
          selected={scholarSelected === params.row.scholarAddress}
          colors={colors}
        >
          {scholarSelected === params.row.scholarAddress
            ? "Selected"
            : "Select"}
        </StyledButton>
      ),
    },
    {
      field: "details",
      headerName: "Details",
      flex: 0.7,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <StyledButton onClick={() => console.log("status")} colors={colors}>
          View More
        </StyledButton>
      ),
    },
  ];

  return (
    <Box m="0px 0 0 20px" width="100%" height={"500px"}>
      <Box
        height="100%"
        // height={"75vh"}
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
            outline: "none !important",
          },
          "& .MuiDataGrid-row": {
            height: "98px !important",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid #E8ECF5",
            outline: "none !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.whiteAccent[500],
            borderBottom: "none",
            outline: "none !important",
          },
          "& .MuiDataGrid-columnHeader": {
            outline: "none !important",
            color: colors.black[500],
            fontSize: "16px",
          },
          "& .MuiDataGrid-columnSeparator": {
            visibility: "hidden",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.whiteAccent[500],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.whiteAccent[500],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={data}
          columns={columns}
          density="comfortable"
          disableColumnSelector={true}
          disableColumnFilter={true}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          hideFooter={true}
          getRowId={(row) => row._id}
        />
      </Box>
    </Box>
  );
};

export default ScholarTableView;
